import { QueryClient } from '@tanstack/react-query'

// Create a client with default configuration
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 5 minutes
      staleTime: 5 * 60 * 1000,
      
      // Cache persists for 10 minutes
      gcTime: 10 * 60 * 1000, // Renamed from cacheTime in v5
      
      // Don't refetch on window focus in development
      refetchOnWindowFocus: process.env.NODE_ENV === 'production',
      
      // Retry failed requests once
      retry: 1,
    },
    
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
})

// Global error handling can be added via QueryCache callbacks if needed
// Example:
// new QueryClient({
//   queryCache: new QueryCache({
//     onError: (error) => console.error(error),
//   }),
// })

